import { Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PendingChangesModalBodyWrapperStyled = styled(Paper)(
  ({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '594px',
    padding: '36px 32px 116px 32px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '100%',
    },
  })
);
